import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { showToast, postData } from '@/src/globalFunction';

class CopyFileUrl extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fileId, sourceId, projectId } = this.props;
    const handleCopyURL = () => {
      const textToCopy =
        window.location.origin +
        `/account#/projects/${projectId}/files?action=copy&file-id=${fileId}&source-id=${sourceId}`;
      // document.body.appendChild(textField);
      // textField.select();
      // document.execCommand('copy');
      // textField.remove();
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          showToast('success', 'File URL copied to clipboard');
        })
        .catch((error) => {
          console.log(`Copy failed! ${error}`);
        });

      const data = [
        {
          linkType: 'document',
          linkId: sourceId,
          actionType: 'copy',
          title: 'copy file url of',
          projectId: projectId,
          activity: 'Copy File URL',
        },
      ];

      postData('/api/userActivity', { type: 'file', data }, () => null);
    };

    if (this.props.iconOnly) {
      return (
        <a onClick={handleCopyURL} data-tooltip-id={`actionItem_ copyUrlIconOnly`}>
          <i className="material-icons">insert_link</i>
          <Tooltip id={`actionItem_ copyUrlIconOnly`} place="bottom" effect="solid">
            Copy File URL
          </Tooltip>
        </a>
      );
    }

    return (
      <a onClick={handleCopyURL}>
        Copy File URL
        <i className="material-icons">insert_link</i>
      </a>
    );
  }
}

export default CopyFileUrl;
